import CloseAccount from './CloseAccount';

export default CloseAccount;
